// extracted by mini-css-extract-plugin
module.exports = {"teaser":"Activity_teaser__8PLSE","video":"Activity_video__5XLIZ","text":"Activity_text__R3WLI","card":"Activity_card__vhQzA"};